import React, { useState } from 'react';
import { X, History, CheckCircle, AlertTriangle } from 'lucide-react';
import { StatusBadge } from './StatusBadge';
const posCollectionHistory = [{
  id: 'POS-90012',
  paymentId: 'PAY-100001',
  date: '14 Jan 2026',
  time: '02:45 PM',
  amount: 'PKR 49,667',
  channel: 'POS Terminal',
  reference: 'TXN-554120',
  status: 'Success'
}, {
  id: 'POS-90013',
  paymentId: 'PAY-100002',
  date: '15 Feb 2026',
  time: '10:20 AM',
  amount: 'PKR 49,367',
  channel: 'POS Terminal',
  reference: 'TXN-554871',
  status: 'Success'
}, {
  id: 'POS-90014',
  paymentId: 'PAY-100003',
  date: '14 Mar 2026',
  time: '03:10 PM',
  amount: 'PKR 49,067',
  channel: 'POS Terminal',
  reference: 'TXN-555302',
  status: 'Success'
}, {
  id: 'POS-90015',
  paymentId: 'PAY-100004',
  date: '15 Apr 2026',
  time: '09:55 AM',
  amount: 'PKR 48,767',
  channel: 'POS Terminal',
  reference: 'TXN-556044',
  status: 'Success'
}, {
  id: 'POS-90016',
  paymentId: 'PAY-100005',
  date: '16 May 2026',
  time: '11:30 AM',
  amount: 'PKR 48,467',
  channel: 'POS Terminal',
  reference: 'TXN-556810',
  status: 'Failed'
}];
interface ApplicationDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  data: any;
}
// Each installment is now broken into separate payment rows.
// Regular installment rows have principal/interest/fees populated.
// Penalty rows are SEPARATE rows with principal/interest/fees as null ('—') and only penalty populated.
// Each row carries a unique paymentId.
type PaymentRow = {
  paymentId: string;
  installmentNo: number;
  type: 'Installment' | 'Penalty';
  due: string;
  principal: string;
  interest: string;
  fees: string;
  penalty: string;
  total: string;
  status: string;
  paidDate: string;
};
const paymentRows: PaymentRow[] = [{
  paymentId: 'PAY-100001',
  installmentNo: 1,
  type: 'Installment',
  due: '15 Jan 2026',
  principal: 'PKR 41,667',
  interest: 'PKR 7,500',
  fees: 'PKR 500',
  penalty: '—',
  total: 'PKR 49,667',
  status: 'Paid',
  paidDate: '14 Jan 2026'
}, {
  paymentId: 'PAY-100002',
  installmentNo: 2,
  type: 'Installment',
  due: '15 Feb 2026',
  principal: 'PKR 41,667',
  interest: 'PKR 7,200',
  fees: 'PKR 500',
  penalty: '—',
  total: 'PKR 49,367',
  status: 'Paid',
  paidDate: '15 Feb 2026'
}, {
  paymentId: 'PAY-100003',
  installmentNo: 3,
  type: 'Installment',
  due: '15 Mar 2026',
  principal: 'PKR 41,667',
  interest: 'PKR 6,900',
  fees: 'PKR 500',
  penalty: '—',
  total: 'PKR 49,067',
  status: 'Paid',
  paidDate: '14 Mar 2026'
}, {
  paymentId: 'PAY-100004',
  installmentNo: 4,
  type: 'Installment',
  due: '15 Apr 2026',
  principal: 'PKR 41,667',
  interest: 'PKR 6,600',
  fees: 'PKR 500',
  penalty: '—',
  total: 'PKR 48,767',
  status: 'Paid',
  paidDate: '15 Apr 2026'
}, {
  paymentId: 'PAY-100005',
  installmentNo: 5,
  type: 'Installment',
  due: '15 May 2026',
  principal: 'PKR 41,667',
  interest: 'PKR 6,300',
  fees: 'PKR 500',
  penalty: '—',
  total: 'PKR 48,467',
  status: 'Overdue',
  paidDate: '—'
}, {
  paymentId: 'PAY-100006',
  installmentNo: 5,
  type: 'Penalty',
  due: '15 May 2026',
  principal: '—',
  interest: '—',
  fees: '—',
  penalty: 'PKR 500',
  total: 'PKR 500',
  status: 'Pending',
  paidDate: '—'
}, {
  paymentId: 'PAY-100007',
  installmentNo: 6,
  type: 'Installment',
  due: '15 Jun 2026',
  principal: 'PKR 41,667',
  interest: 'PKR 6,000',
  fees: 'PKR 500',
  penalty: '—',
  total: 'PKR 48,167',
  status: 'Pending',
  paidDate: '—'
}, {
  paymentId: 'PAY-100008',
  installmentNo: 7,
  type: 'Installment',
  due: '15 Jul 2026',
  principal: 'PKR 41,667',
  interest: 'PKR 5,700',
  fees: 'PKR 500',
  penalty: '—',
  total: 'PKR 47,867',
  status: 'Pending',
  paidDate: '—'
}, {
  paymentId: 'PAY-100009',
  installmentNo: 8,
  type: 'Installment',
  due: '15 Aug 2026',
  principal: 'PKR 41,667',
  interest: 'PKR 5,400',
  fees: 'PKR 500',
  penalty: '—',
  total: 'PKR 47,567',
  status: 'Pending',
  paidDate: '—'
}, {
  paymentId: 'PAY-100010',
  installmentNo: 9,
  type: 'Installment',
  due: '15 Sep 2026',
  principal: 'PKR 41,667',
  interest: 'PKR 5,100',
  fees: 'PKR 500',
  penalty: '—',
  total: 'PKR 47,267',
  status: 'Pending',
  paidDate: '—'
}, {
  paymentId: 'PAY-100011',
  installmentNo: 10,
  type: 'Installment',
  due: '15 Oct 2026',
  principal: 'PKR 41,667',
  interest: 'PKR 4,800',
  fees: 'PKR 500',
  penalty: '—',
  total: 'PKR 46,967',
  status: 'Pending',
  paidDate: '—'
}, {
  paymentId: 'PAY-100012',
  installmentNo: 11,
  type: 'Installment',
  due: '15 Nov 2026',
  principal: 'PKR 41,667',
  interest: 'PKR 4,500',
  fees: 'PKR 500',
  penalty: '—',
  total: 'PKR 46,667',
  status: 'Pending',
  paidDate: '—'
}, {
  paymentId: 'PAY-100013',
  installmentNo: 12,
  type: 'Installment',
  due: '15 Dec 2026',
  principal: 'PKR 41,663',
  interest: 'PKR 4,200',
  fees: 'PKR 500',
  penalty: '—',
  total: 'PKR 46,363',
  status: 'Pending',
  paidDate: '—'
}];
export function ApplicationDetailModal({
  isOpen,
  onClose,
  data
}: ApplicationDetailModalProps) {
  const [showPosHistory, setShowPosHistory] = useState(false);
  const [confirmAction, setConfirmAction] = useState<{
    type: 'paid' | 'cancel';
    row: PaymentRow;
  } | null>(null);
  if (!isOpen || !data) return null;
  const handleConfirm = () => {
    // In a real app this would update the payment record / call an API.
    setConfirmAction(null);
  };
  const paidCount = paymentRows.filter(r => r.type === 'Installment' && r.status === 'Paid').length;
  const totalInstallments = paymentRows.filter(r => r.type === 'Installment').length;
  const remainingCount = totalInstallments - paidCount;
  const effectiveStatus = data.status || 'Active';
  const showRepaymentHistory = effectiveStatus === 'Active' || effectiveStatus === 'Settled';
  const getActivityLog = () => {
    const logs = [{
      type: 'Application Created',
      description: 'Loan application submitted by customer',
      date: '10 Jan 2026',
      time: '09:15 AM'
    }];
    if (effectiveStatus === 'Active' || effectiveStatus === 'Settled') {
      logs.push({
        type: 'Loan Disbursed',
        description: 'Funds transferred via RAAST to customer account',
        date: '12 Jan 2026',
        time: '11:30 AM'
      }, {
        type: 'Repayment Paid',
        description: 'Installment #1 received — PKR 49,667',
        date: '14 Jan 2026',
        time: '02:45 PM'
      }, {
        type: 'Repayment Paid',
        description: 'Installment #2 received — PKR 49,367',
        date: '15 Feb 2026',
        time: '10:20 AM'
      }, {
        type: 'Repayment Paid',
        description: 'Installment #3 received — PKR 49,067',
        date: '14 Mar 2026',
        time: '03:10 PM'
      }, {
        type: 'Repayment Paid',
        description: 'Installment #4 received — PKR 48,767',
        date: '15 Apr 2026',
        time: '09:55 AM'
      }, {
        type: 'Penalty Applied',
        description: 'Late payment penalty of PKR 500 applied on installment #5',
        date: '16 May 2026',
        time: '12:00 PM'
      });
    }
    if (effectiveStatus === 'Settled') {
      logs.push({
        type: 'Loan Settled',
        description: 'All outstanding dues cleared. Loan marked as settled.',
        date: '15 Dec 2026',
        time: '04:30 PM'
      });
    }
    return logs.reverse();
  };
  const activityLog = getActivityLog();
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-97">
      <div className="fixed inset-0 bg-gray-900/50 transition-opacity" onClick={onClose} aria-hidden="true" data-id="element-98" />

      <div className="relative w-full max-w-5xl max-h-[90vh] flex flex-col bg-white rounded-lg shadow-xl transition-all" data-id="element-99">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200" data-id="element-100">
          <h3 className="text-lg font-semibold leading-6 text-gray-900" data-id="element-101">
            Loan Detail View
          </h3>
          <div className="flex items-center gap-3" data-id="element-102">
            <button type="button" onClick={() => setShowPosHistory(true)} className="inline-flex items-center rounded-md bg-white px-3 py-1.5 text-sm font-medium text-blue-700 ring-1 ring-inset ring-blue-200 hover:bg-blue-50" data-id="element-103">
              <History className="h-4 w-4 mr-1.5" data-id="element-104" />
              View POS Collection History
            </button>
            <button type="button" className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none" onClick={onClose} data-id="element-105">
              <span className="sr-only" data-id="element-106">Close</span>
              <X className="h-6 w-6" aria-hidden="true" data-id="element-107" />
            </button>
          </div>
        </div>

        {/* Scrollable Content */}
        <div className="flex-1 overflow-y-auto p-6 space-y-8" data-id="element-108">
          {/* SECTION 1: APPLICATION DETAILS */}
          <div data-id="element-109">
            <h4 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4 border-b border-gray-100 pb-2" data-id="element-110">
              Application Details
            </h4>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-4" data-id="element-111">
              <div data-id="element-112">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-113">
                  Application ID
                </dt>
                <dd className="mt-1 text-sm text-gray-900" data-id="element-114">
                  {data.id || 'APP-55678'}
                </dd>
              </div>
              <div data-id="element-115">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-116">
                  Loan ID
                </dt>
                <dd className="mt-1 text-sm text-gray-900" data-id="element-117">
                  {data.loanId || 'LN-10234'}
                </dd>
              </div>
              <div data-id="element-118">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-119">
                  Customer ID
                </dt>
                <dd className="mt-1 text-sm text-gray-900" data-id="element-120">
                  {data.customerId || 'CUST-10234'}
                </dd>
              </div>
              <div data-id="element-121">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-122">
                  Customer Name
                </dt>
                <dd className="mt-1 text-sm text-gray-900" data-id="element-123">
                  {data.applicant || data.customerName || 'Khan Enterprises'}
                </dd>
              </div>
              <div data-id="element-124">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-125">
                  Customer CNIC / ID
                </dt>
                <dd className="mt-1 text-sm text-gray-900" data-id="element-126">42101-1234567-1</dd>
              </div>
              <div data-id="element-127">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-128">
                  Product Name
                </dt>
                <dd className="mt-1 text-sm text-gray-900" data-id="element-129">
                  Business Term Loan
                </dd>
              </div>
              <div data-id="element-130">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-131">
                  Loan Amount
                </dt>
                <dd className="mt-1 text-sm text-gray-900" data-id="element-132">
                  {data.amount || 'PKR 500,000'}
                </dd>
              </div>
              <div data-id="element-133">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-134">
                  Tenure
                </dt>
                <dd className="mt-1 text-sm text-gray-900" data-id="element-135">
                  {data.tenure || '12 months'}
                </dd>
              </div>
              <div data-id="element-136">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-137">
                  Interest Type
                </dt>
                <dd className="mt-1 text-sm text-gray-900" data-id="element-138">Reducing Balance</dd>
              </div>
              <div data-id="element-139">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-140">
                  Interest Rate
                </dt>
                <dd className="mt-1 text-sm text-gray-900" data-id="element-141">17%</dd>
              </div>
              <div data-id="element-142">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-143">
                  Application Status
                </dt>
                <dd className="mt-1" data-id="element-144">
                  <StatusBadge status={data.status || 'Active'} data-id="element-145" />
                </dd>
              </div>
              <div data-id="element-146">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-147">
                  Application Date
                </dt>
                <dd className="mt-1 text-sm text-gray-900" data-id="element-148">
                  {data.submissionDate || data.date || '10 Jan 2026'}
                </dd>
              </div>
              <div data-id="element-149">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-150">
                  Default Trigger
                </dt>
                <dd className="mt-1 text-sm text-gray-900" data-id="element-151">45 days</dd>
              </div>
              <div data-id="element-152">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-153">
                  Grace Period
                </dt>
                <dd className="mt-1 text-sm text-gray-900" data-id="element-154">5 days</dd>
              </div>
              <div data-id="element-155">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-156">
                  Processing Fees
                </dt>
                <dd className="mt-1 text-sm text-gray-900" data-id="element-157">0.1%</dd>
              </div>
            </div>
          </div>

          {/* SECTION 2: DISBURSEMENT STATUS & ACTION */}
          <div data-id="element-158">
            <h4 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4 border-b border-gray-100 pb-2" data-id="element-159">
              Disbursement Status & Action
            </h4>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-4" data-id="element-160">
              <div data-id="element-161">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-162">
                  Disbursement Status
                </dt>
                <dd className="mt-1" data-id="element-163">
                  <StatusBadge status={data.status === 'Active' || data.status === 'Settled' ? 'Disbursed' : 'Pending'} data-id="element-164" />
                </dd>
              </div>
              <div data-id="element-165">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-166">
                  Disbursement Method
                </dt>
                <dd className="mt-1 text-sm text-gray-900" data-id="element-167">
                  {data.method || 'RAAST'}
                </dd>
              </div>
              <div data-id="element-168">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-169">
                  Disbursement Date
                </dt>
                <dd className="mt-1 text-sm text-gray-900" data-id="element-170">
                  {data.status === 'Active' || data.status === 'Settled' ? '12 Jan 2026' : '—'}
                </dd>
              </div>
            </div>
          </div>

          {/* SECTION 3: REPAYMENT DETAILS & HISTORY */}
          <div data-id="element-171">
            <h4 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4 border-b border-gray-100 pb-2" data-id="element-172">
              Repayment Details & History
            </h4>

            {showRepaymentHistory ? <>
                {/* Summary Cards */}
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 mb-6" data-id="element-173">
                  <div className="bg-gray-50 p-3 rounded-lg border border-gray-200" data-id="element-174">
                    <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-175">
                      Total Installments
                    </dt>
                    <dd className="mt-1 text-base font-bold text-gray-900" data-id="element-176">
                      {totalInstallments}
                    </dd>
                  </div>
                  <div className="bg-gray-50 p-3 rounded-lg border border-gray-200" data-id="element-177">
                    <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-178">
                      Paid
                    </dt>
                    <dd className="mt-1 text-base font-bold text-emerald-700" data-id="element-179">
                      {paidCount}
                    </dd>
                  </div>
                  <div className="bg-gray-50 p-3 rounded-lg border border-gray-200" data-id="element-180">
                    <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-181">
                      Remaining
                    </dt>
                    <dd className="mt-1 text-base font-bold text-gray-900" data-id="element-182">
                      {remainingCount}
                    </dd>
                  </div>
                  <div className="bg-gray-50 p-3 rounded-lg border border-gray-200" data-id="element-183">
                    <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-184">
                      Total Paid
                    </dt>
                    <dd className="mt-1 text-base font-bold text-gray-900" data-id="element-185">
                      PKR 196,868
                    </dd>
                  </div>
                  <div className="bg-gray-50 p-3 rounded-lg border border-gray-200" data-id="element-186">
                    <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-187">
                      Outstanding
                    </dt>
                    <dd className="mt-1 text-base font-bold text-blue-600" data-id="element-188">
                      PKR 377,832
                    </dd>
                  </div>
                  <div className="bg-gray-50 p-3 rounded-lg border border-gray-200" data-id="element-189">
                    <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-190">
                      Penalty Accrued
                    </dt>
                    <dd className="mt-1 text-base font-bold text-red-600" data-id="element-191">
                      PKR 500
                    </dd>
                  </div>
                </div>

                {/* Payment Rows Table */}
                <div className="overflow-x-auto ring-1 ring-gray-200 rounded-lg" data-id="element-192">
                  <table className="min-w-full divide-y divide-gray-200" data-id="element-193">
                    <thead className="bg-gray-50" data-id="element-194">
                      <tr data-id="element-195">
                        <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-196">
                          Payment ID
                        </th>
                        <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-197">
                          Inst. #
                        </th>
                        <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-198">
                          Type
                        </th>
                        <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-199">
                          Due Date
                        </th>
                        <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-200">
                          Principal
                        </th>
                        <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-201">
                          Interest
                        </th>
                        <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-202">
                          Fees
                        </th>
                        <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-203">
                          Penalty
                        </th>
                        <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-204">
                          Total
                        </th>
                        <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-205">
                          Status
                        </th>
                        <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-206">
                          Paid Date
                        </th>
                        <th scope="col" className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-207">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200" data-id="element-208">
                      {paymentRows.map(row => {
                    const isPenalty = row.type === 'Penalty';
                    const canTakeAction = row.status !== 'Paid' && row.status !== 'Settled';
                    return <tr key={row.paymentId} className={row.status === 'Overdue' ? 'bg-red-50' : isPenalty ? 'bg-amber-50/40' : ''} data-id="element-209">
                            <td className="px-4 py-2 text-sm font-medium text-gray-900 whitespace-nowrap" data-id="element-210">
                              {row.paymentId}
                            </td>
                            <td className="px-4 py-2 text-sm text-gray-900" data-id="element-211">
                              {row.installmentNo}
                            </td>
                            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-212">
                              {isPenalty ? <span className="inline-flex items-center rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-800" data-id="element-213">
                                  Penalty
                                </span> : <span className="inline-flex items-center rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-700" data-id="element-214">
                                  Installment
                                </span>}
                            </td>
                            <td className="px-4 py-2 text-sm text-gray-500 whitespace-nowrap" data-id="element-215">
                              {row.due}
                            </td>
                            <td className="px-4 py-2 text-sm text-gray-900" data-id="element-216">
                              {row.principal}
                            </td>
                            <td className="px-4 py-2 text-sm text-gray-900" data-id="element-217">
                              {row.interest}
                            </td>
                            <td className="px-4 py-2 text-sm text-gray-900" data-id="element-218">
                              {row.fees}
                            </td>
                            <td className="px-4 py-2 text-sm text-red-600" data-id="element-219">
                              {row.penalty}
                            </td>
                            <td className="px-4 py-2 text-sm font-medium text-gray-900" data-id="element-220">
                              {row.total}
                            </td>
                            <td className="px-4 py-2" data-id="element-221">
                              <StatusBadge status={row.status} data-id="element-222" />
                            </td>
                            <td className="px-4 py-2 text-sm text-gray-500 whitespace-nowrap" data-id="element-223">
                              {row.paidDate}
                            </td>
                            <td className="px-4 py-2 text-right text-sm whitespace-nowrap" data-id="element-224">
                              {canTakeAction ? <div className="flex items-center justify-end gap-2" data-id="element-225">
                                  <button type="button" onClick={() => setConfirmAction({
                            type: 'paid',
                            row
                          })} className="inline-flex items-center rounded-md bg-emerald-50 px-2.5 py-1 text-xs font-medium text-emerald-700 ring-1 ring-inset ring-emerald-200 hover:bg-emerald-100" data-id="element-226">
                                    Mark as Paid
                                  </button>
                                  <button type="button" onClick={() => setConfirmAction({
                            type: 'cancel',
                            row
                          })} className="inline-flex items-center rounded-md bg-red-50 px-2.5 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-200 hover:bg-red-100" data-id="element-227">
                                    Cancel POS Recovery
                                  </button>
                                </div> : <span className="text-xs text-gray-400" data-id="element-228">—</span>}
                            </td>
                          </tr>;
                  })}
                    </tbody>
                  </table>
                </div>
              </> : <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 text-center" data-id="element-229">
                <p className="text-sm text-gray-500" data-id="element-230">
                  No repayment history available. Loan has not been disbursed.
                </p>
              </div>}
          </div>

          {/* SECTION 4: ACTIVITY LOG */}
          <div data-id="element-231">
            <h4 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4 border-b border-gray-100 pb-2" data-id="element-232">
              Activity Log
            </h4>
            <div className="overflow-x-auto ring-1 ring-gray-200 rounded-lg" data-id="element-233">
              <table className="min-w-full divide-y divide-gray-200" data-id="element-234">
                <thead className="bg-gray-50" data-id="element-235">
                  <tr data-id="element-236">
                    <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-237">
                      Activity Type
                    </th>
                    <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-238">
                      Description
                    </th>
                    <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-239">
                      Date
                    </th>
                    <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-240">
                      Time
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200" data-id="element-241">
                  {activityLog.map((entry, idx) => <tr key={idx} data-id="element-242">
                      <td className="px-4 py-2 text-sm font-medium text-gray-900" data-id="element-243">
                        {entry.type}
                      </td>
                      <td className="px-4 py-2 text-sm text-gray-500" data-id="element-244">
                        {entry.description}
                      </td>
                      <td className="px-4 py-2 text-sm text-gray-500" data-id="element-245">
                        {entry.date}
                      </td>
                      <td className="px-4 py-2 text-sm text-gray-500" data-id="element-246">
                        {entry.time}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="bg-gray-50 px-6 py-4 flex flex-row-reverse gap-3 rounded-b-lg border-t border-gray-200" data-id="element-247">
          <button type="button" className="inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:w-auto" onClick={onClose} data-id="element-248">
            Close
          </button>
        </div>
      </div>

      {/* POS COLLECTION HISTORY MODAL */}
      {showPosHistory && <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 sm:p-6" data-id="element-249">
          <div className="fixed inset-0 bg-gray-900/50" onClick={() => setShowPosHistory(false)} aria-hidden="true" data-id="element-250" />
          <div className="relative w-full max-w-3xl max-h-[85vh] flex flex-col bg-white rounded-lg shadow-xl" data-id="element-251">
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200" data-id="element-252">
              <h3 className="text-lg font-semibold leading-6 text-gray-900" data-id="element-253">
                POS Collection History
              </h3>
              <button type="button" className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none" onClick={() => setShowPosHistory(false)} data-id="element-254">
                <span className="sr-only" data-id="element-255">Close</span>
                <X className="h-6 w-6" aria-hidden="true" data-id="element-256" />
              </button>
            </div>
            <div className="flex-1 overflow-y-auto p-6" data-id="element-257">
              <div className="overflow-x-auto ring-1 ring-gray-200 rounded-lg" data-id="element-258">
                <table className="min-w-full divide-y divide-gray-200" data-id="element-259">
                  <thead className="bg-gray-50" data-id="element-260">
                    <tr data-id="element-261">
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-262">
                        Collection ID
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-263">
                        Payment ID
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-264">
                        Date
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-265">
                        Time
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-266">
                        Amount
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-267">
                        Channel
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-268">
                        Reference
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-269">
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200" data-id="element-270">
                    {posCollectionHistory.map(row => <tr key={row.id} data-id="element-271">
                        <td className="px-4 py-2 text-sm font-medium text-gray-900 whitespace-nowrap" data-id="element-272">
                          {row.id}
                        </td>
                        <td className="px-4 py-2 text-sm text-gray-500 whitespace-nowrap" data-id="element-273">
                          {row.paymentId}
                        </td>
                        <td className="px-4 py-2 text-sm text-gray-500 whitespace-nowrap" data-id="element-274">
                          {row.date}
                        </td>
                        <td className="px-4 py-2 text-sm text-gray-500 whitespace-nowrap" data-id="element-275">
                          {row.time}
                        </td>
                        <td className="px-4 py-2 text-sm font-medium text-gray-900 whitespace-nowrap" data-id="element-276">
                          {row.amount}
                        </td>
                        <td className="px-4 py-2 text-sm text-gray-500 whitespace-nowrap" data-id="element-277">
                          {row.channel}
                        </td>
                        <td className="px-4 py-2 text-sm text-gray-500 whitespace-nowrap" data-id="element-278">
                          {row.reference}
                        </td>
                        <td className="px-4 py-2" data-id="element-279">
                          <StatusBadge status={row.status} data-id="element-280" />
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="bg-gray-50 px-6 py-4 flex flex-row-reverse rounded-b-lg border-t border-gray-200" data-id="element-281">
              <button type="button" className="inline-flex justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50" onClick={() => setShowPosHistory(false)} data-id="element-282">
                Close
              </button>
            </div>
          </div>
        </div>}

      {/* CONFIRMATION MODAL */}
      {confirmAction && <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" data-id="element-283">
          <div className="fixed inset-0 bg-gray-900/50" onClick={() => setConfirmAction(null)} aria-hidden="true" data-id="element-284" />
          <div className="relative w-full max-w-md bg-white rounded-lg shadow-xl p-6" data-id="element-285">
            <div className="flex items-start gap-4" data-id="element-286">
              <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${confirmAction.type === 'paid' ? 'bg-emerald-100' : 'bg-red-100'}`} data-id="element-287">
                {confirmAction.type === 'paid' ? <CheckCircle className="h-6 w-6 text-emerald-600" data-id="element-288" /> : <AlertTriangle className="h-6 w-6 text-red-600" data-id="element-289" />}
              </div>
              <div className="flex-1" data-id="element-290">
                <h3 className="text-base font-semibold text-gray-900" data-id="element-291">
                  {confirmAction.type === 'paid' ? 'Mark Payment as Paid' : 'Cancel POS Recovery'}
                </h3>
                <p className="mt-2 text-sm text-gray-500" data-id="element-292">
                  {confirmAction.type === 'paid' ? <>
                      Are you sure you want to mark payment{' '}
                      <span className="font-medium text-gray-900" data-id="element-293">
                        {confirmAction.row.paymentId}
                      </span>{' '}
                      ({confirmAction.row.total}) as paid? This action will be
                      recorded in the activity log.
                    </> : <>
                      Are you sure you want to cancel POS recovery for payment{' '}
                      <span className="font-medium text-gray-900" data-id="element-294">
                        {confirmAction.row.paymentId}
                      </span>
                      ? The scheduled point-of-sale collection will be stopped.
                    </>}
                </p>
              </div>
            </div>
            <div className="mt-6 flex flex-row-reverse gap-3" data-id="element-295">
              <button type="button" onClick={handleConfirm} className={`inline-flex justify-center rounded-md px-4 py-2 text-sm font-semibold text-white shadow-sm ${confirmAction.type === 'paid' ? 'bg-emerald-600 hover:bg-emerald-500' : 'bg-red-600 hover:bg-red-500'}`} data-id="element-296">
                {confirmAction.type === 'paid' ? 'Confirm Payment' : 'Cancel Recovery'}
              </button>
              <button type="button" onClick={() => setConfirmAction(null)} className="inline-flex justify-center rounded-md bg-white px-4 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50" data-id="element-297">
                Go Back
              </button>
            </div>
          </div>
        </div>}
    </div>;
}